export const VALIDATION_MESSAGES = {
  required: 'This field is required',
  invalidEmail: 'Given email address is invalid',
};
